export const environment = {
  production: true,
  API:'https://blagnacapi.exlineo.com/',
  VIDEOS:'https://www.googleapis.com/youtube/v3/',
  VIDEOS_LIST:'PLq6Xs9pipX79Dh0EHy8Ttnc8RbqyoWRel',
  VIDEOS_CLE:'',
  // VIDEOS_AUTH:'734309347837-ar80hmmeiuhev319bn965uia3v76sgd9.apps.googleusercontent.com'
  VIDEOS_AUTH:'',
  VIDEOS_CHAN:'UC7k9DYI7_p_C8rDEH8aBlOg',
  VIDEOS_ID:''
};
